<template>
  <div v-if="!loading">
    <form>
      <v-text-field
        v-model="item.comment"
        label="Dôvod vytvorenia"
        readonly
      />
      <v-text-field
        v-model="item.created_at"
        label="Dátum vytvorenia"
        readonly
      />
      <v-text-field
        v-model="item.updated_at"
        label="Dátum poslednej úpravy"
        readonly
      />
      <v-text-field
        v-model="item.prisoner_full.base_number"
        label="Základné číslo"
        readonly
      />
      <v-select
        v-model="item.institution"
        item-text="name"
        item-value="id"
        label="Ústav"
        :items="institutions"
        auto-select-first
        :search-input.sync="search_institutions"
        cache-items
        :loading="loading_institutions"
        hide-no-data
      />

      <v-text-field
        v-model="item.prisoner_full.birth_date"
        label="Dátum narodenia"
        readonly
      />

      <v-divider class="mt-10" />

      <v-layout
        v-if="!item.closed"
        pt-5
      >
        <v-btn
          dark
          color="indigo"
          @click="updateItem"
        >
          Uložiť
        </v-btn>
        <div class="flex-grow-1" />
      </v-layout>
    </form>

    <v-snackbar
      v-model="snackbar_saved"
      color="success"
      :timeout="3000"
    >
      Uložené
      <v-btn
        text
        @click="snackbar_saved = false"
      >
        Zavrieť
      </v-btn>
    </v-snackbar>
    <v-snackbar
      v-model="snackbar_error"
      color="error"
      :timeout="5000"
    >
      Chyba
    </v-snackbar>
  </div>

  <div v-else>
    <form-skeleton-component skeleton_type="simple" />
  </div>
</template>

<script>
import { APIService } from "@/http/APIService.js";
import FormSkeleton from "../../components/FormSkeleton.vue";

const apiService = new APIService();

export default {

  components: {
    "form-skeleton-component": FormSkeleton,
  },

  data: () => ({
    loading: false,
    loading_institutions: false,
    snackbar_saved: false,
    snackbar_error: false,

    search_institutions: null,

    institutions: [],

    item: {
      prisoner_full: {
        comment: "",
        base_number: "",
        birth_date: ""
      },
      institution_full: {
        name: ""
      }
    }
  }),

  computed: {},

  watch: {
    search_institutions(val) {
      val && this.queryselections_institutions(val);
    },
  },

  mounted() {
    this.getItem();
    this.queryselections_institutions("");
  },

  methods: {
    queryselections_institutions(v) {
      this.loading_institutions = true;

      apiService.searchInstitutions(v).then((response) => {
        this.institutions = response.results;
        this.loading_institutions = false;
      });
    },

    getItem() {
      this.loading = true;
      apiService.getCraForm(this.$route.params.id).then(response => {
        this.item = response;
        this.loading = false;
      });
    },

    updateItem() {
      apiService.updateCraForm(this.item).then(response => {
        this.item = response;
        this.snackbar_saved = true;
      })
    }
  },
};
</script>